import {
  SubscriptionDashboardHeader,
  SubscriptionSummarySection,
  SubscriptionGrowthSection,
  SubscriptionPlanChartsSection,
  SubscriptionPlanDetailsSection,
  getRevenueByPlan,
  getPlanDistribution,
} from "../../../components/reportDashboard/subscribtions/subcribtions";
import { useSubscriptionsReport, useReportDateRange } from "../../../hooks/useReportDashboard";
import { ErrorRetry } from "../../../components/common/ErrorRetry";
import { mapSubscriptionSummaryToKpis } from "../../../utils/subscriptionSummary";

export function Subscriptions() {
  const { dateRange, onDateRangeChange } = useReportDateRange();
  const {
    data: subscriptionReportsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useSubscriptionsReport(dateRange);

  if (isError)
    return (
      <ErrorRetry
        message={error?.message || "Unexpected error"}
        onRetry={refetch}
      />
    );

  const revenueByPlan = getRevenueByPlan(subscriptionReportsData);
  const planDistribution = getPlanDistribution(subscriptionReportsData);
  const subscriptionSummaryCards = mapSubscriptionSummaryToKpis(
    subscriptionReportsData?.data?.subscriptionSummary,
  );
  const subscriberGrowthTrend =
    subscriptionReportsData?.data?.subscriberGrowthTrendAnnual || [];

  return (
    <div className="space-y-6">
      <SubscriptionDashboardHeader onDateRangeChange={onDateRangeChange} />

      <SubscriptionSummarySection
        loading={isLoading}
        summaryCards={subscriptionSummaryCards}
      />

      <SubscriptionGrowthSection
        loading={isLoading}
        growthData={subscriberGrowthTrend}
      />

      <SubscriptionPlanChartsSection
        loading={isLoading}
        revenueByPlan={revenueByPlan}
        planDistribution={planDistribution}
      />

      <SubscriptionPlanDetailsSection
        loading={isLoading}
        subscriptionData={subscriptionReportsData?.data}
      />
    </div>
  );
}
